<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on"> mdi-plus </v-icon>
    </template>
    <!-- maincard -->
    <v-card elevation="0" width="500" height="550" style="overflow: hidden">
      <h3 style="color: #ff00ff" class="pl-8">Tags</h3>
      <!-- inner card thin 1 large -->
      <v-card elevation="0" width="500" height="4" color="#E5E4E2">
        <!-- inner card thin 2 small -->
        <v-card
          elevation="0"
          width="40"
          height="4"
          class="ml-7"
          color="#FF00FF"
        >
        </v-card>
      </v-card>
      <!-- 4 card big inner to main card  -->
      <v-card elevation="0" width="470" height="370" class="ml-4 mt-2 expand">
        <!-- show inner layout card-->
        <div v-for="(item, index) in localtags" :key="index">
          <v-card
            elevation="0"
            width="455"
            rounded="xl"
            height="48"
            class="mt-2"
            color="#E5E4E2"
          >
            <div style="display: flex" class="ml-4">
              <v-icon class="" :color="item.color">local_offer</v-icon>
              <div style="width: 23em">
                <p class="ml-6 mt-3">{{ item.title }}</p>
              </div>
              <v-btn icon :style="{ color: item.color }" v-on="on">
                <v-icon size="22">mdi-moon-full</v-icon>
              </v-btn>
              <v-btn icon class="mt-1" @click="deleteTag(item)">
                <v-icon>mdi-close</v-icon></v-btn
              >
            </div>
          </v-card>
        </div>
        <!-- inner layout card  -->
      </v-card>
      <v-card
        v-if="btntags"
        elevation="0"
        width="455"
        rounded="xl"
        height="48"
        class="ml-4 mt-2"
        color="#E5E4E2"
      >
        <div style="display: flex" class="ml-4">
          <v-icon class="mt-n5" :color="colorTag">local_offer</v-icon>

          <div style="width: 23em" class="ml-2 mt-1">
            <v-text-field
              v-model="textTag"
              @keyup.enter="addTag()"
              dense
              outlined
              class=""
            ></v-text-field>
          </div>
          <v-menu
            ref="menu1"
            rounded="xl"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div class="my-2">
                <v-btn icon :style="{ color: colorTag }" v-on="on">
                  <v-icon size="22">mdi-moon-full</v-icon>
                </v-btn>
                <!-- <v-avatar size="18" :style="{ color: colorTag }" v-on="on"  class="mt-1 ml-3"></v-avatar> -->

                <!-- <v-icon size="40">mdi-moon-full</v-icon> -->
              </div>
            </template>
            <v-color-picker
              mode=""
              hide-canvas
              show-swatches
              v-model="colorTag"
            ></v-color-picker>
          </v-menu>

          <v-icon class="mt-n5 ml-3">mdi-close</v-icon>
        </div>
      </v-card>
      <v-card-actions class="mt-n4">
        <h4
          style="color: #ff00ff; cursor: pointer"
          class="pl-2"
          @click="btntags = !btntags"
        >
          <v-icon color="#FF00FF">mdi-plus</v-icon>Add Tags
        </h4>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Done </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import store from "../store";
export default {
  name: "addFileComponent",
  //components
  components: {},
  //data
  data() {
    return {
      menu1: false,
      dialog: false,
      btntags: false,
      localtags: [],
      textTag: "",

      type: "hex",
      hex: "#FF0000",
    };
  },
  //computed
  computed: {
    colorTag: {
      get() {
        return this[this.type];
      },
      set(v) {
        this[this.type] = v;
      },
    },
  },
  //watch
  watch: {},
  //mounted
  mounted() {
    console.log("iiiiiiiiiiiiiiiiiiiiiiiii");
    this.localtags = store.state.tags;
    this.colorTag = this.randColorHex();
  },
  //methods
  methods: {
    addTag() {
      var obj = {
        title: "",
        color: "",
      };
      if (!this.textTag) {
        return;
      }
      obj.title = this.textTag;
      obj.color = this.colorTag;
      this.localtags.unshift(obj);
      this.textTag = "";
      this.colorTag = this.randColorHex();
      this.$store.commit("setTags", this.localtags);
      this.btntags = false;
    },
    deleteTag(y) {
      var index = this.localtags.findIndex((x) => x.title === y.title);
      //console.log(index);
      this.localtags.splice(index, 1);
      this.$store.commit("setTags", this.localtags);
    },
    randColorHex() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/material-dashboard.scss";
.expand::-webkit-scrollbar {
  width: 5px;
}
.expand {
  overflow-y: scroll;
  scrollbar-color: #a0a0a0 transparent;
  scrollbar-width: thin;
}
.expand::-webkit-scrollbar-track {
  background: transparent;
}
.expand::-webkit-scrollbar-thumb {
  background: #a0a0a0;
  border-radius: 10px;
}
</style>